export type SearchValue = {
  id: string;
  label: string;
};

export const isSearchValueType = (searchValue: string | SearchValue): searchValue is SearchValue => {
  return (searchValue as SearchValue).label !== undefined;
};
